import {
  FETCH_WITHDRAWS,
  FETCH_WITHDRAWS_SUCCESS,
  FETCH_WITHDRAWS_FAILED,
  EDIT_WITHDRAWS
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, child, update, get } from "firebase/database";
import { formatCop } from "../other/currencyFormat";
import { getWalletPromoBalance } from "../other/walletCampaignFunctions";

export const fetchWithdraws = () => (dispatch) => {

  const {
    withdrawRef
  } = firebase;

  dispatch({
    type: FETCH_WITHDRAWS,
    payload: null
  });
 onValue(withdrawRef, snapshot => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });
      dispatch({
        type: FETCH_WITHDRAWS_SUCCESS,
        payload: arr.reverse()
      });
    } else {
      dispatch({
        type: FETCH_WITHDRAWS_FAILED,
        payload: "No WITHDRAWS available."
      });
    }
  });
};

export const completeWithdraw = (entry) => (dispatch) => {

  const {
    withdrawRef
  } = firebase;
  
  dispatch({
    type: EDIT_WITHDRAWS,
    payload: entry
  });
  return update(child(withdrawRef, entry.id), { processed: true, processDate: new Date().getTime() });
}

/**
 * Admin rechaza una solicitud pendiente. Si el servidor ya había descontado el saldo (validated),
 * la Cloud Function `withdrawUpdate` lo devuelve a la billetera y notifica al usuario.
 */
export const rejectWithdraw = (entry, message) => () => {
  const { withdrawRef, auth } = firebase;
  return update(child(withdrawRef, entry.id), {
    rejected: true,
    rejectReason: 'admin',
    rejectMessage: String(message || '').trim().slice(0, 300),
    rejectDate: new Date().getTime(),
    rejectedBy: auth.currentUser ? auth.currentUser.uid : null,
  });
};

const USERTYPE_LABELS = { driver: 'Conductor', customer: 'Pasajero', fleetadmin: 'Fleet admin', admin: 'Admin' };

/** Datos actuales del usuario para que el admin verifique un retiro de billetera. */
export const getWalletWithdrawUserContext = async (uid) => {
  const { singleUserRef } = firebase;
  if (!uid) return null;
  const user = (await get(singleUserRef(uid))).val();
  if (!user) return null;
  const type = USERTYPE_LABELS[user.usertype] || user.usertype || '—';
  return {
    rows: [
      { label: 'Tipo', value: user.cityName ? `${type} · ${user.cityName}` : type },
      { label: 'Saldo actual de billetera', value: formatCop(parseFloat(user.walletBalance) || 0) },
      ...(getWalletPromoBalance(user) > 0
        ? [{ label: 'Saldo de campaña (no retirable)', value: formatCop(getWalletPromoBalance(user)) }]
        : []),
      { label: 'Datos bancarios', value: user.bankName && user.bankAccount ? `${user.bankName} · ${user.bankAccount}` : 'Sin registrar' },
    ],
  };
};